import React, { FunctionComponent, useState } from 'react'
import styled from 'styled-components'
import { GQLCartQuery, useCartLinesAddMutation, useCartLinesRemoveMutation, useCartLinesUpdateMutation } from '../generated/graphql'
import { SvgPlus } from './svg'
import { useCartId } from '../hooks/use-cart-id'
import { formatDecimal } from '../utils/format-decimal'
import classNames from 'classnames'

const Outer = styled.div`
  transition: opacity 0.4s;
  &.updating {
    pointer-events: none;
    opacity: 0.5;
  }
`

const Inner = styled.div`
display: grid;
grid-template-columns: auto 1fr;
gap: 1.25rem;
`

const ImageContainer = styled.div`
  img {
    display: block;
    height: 5.6875rem;
    width: auto;
    aspect-ratio: 1 / 1;
    object-fit: contain;
  }
`

const TextContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`

const Name = styled.div`
font-size: 0.875rem;
line-height: 1.5;
letter-spacing: -0.03em;
font-weight: 700;
font-family: var(--en-serif-font);
margin-right: 2rem;
`

const Volume = styled.div`
font-size: 0.625rem;
line-height: 1.5;
letter-spacing: 0.1em;
font-weight: 400;
`

const Price = styled.div`
font-size: 1.25rem;
line-height: 1;
letter-spacing: -0.03em;
font-weight: 700;
font-family: var(--en-serif-font);
margin-top: auto;
display: flex;
gap: 0.25rem;
margin-right: 2rem;
align-items: baseline;
small {
  font-size: 0.75rem;
}
`

const Qty = styled.div`
  display: block;
  position: absolute;
  bottom: 0;
  right: 0;
  appearance: none;
  color: inherit;
  border: 1px solid currentColor;
  border-radius: 100rem;
  padding: 0.25rem 1.5rem 0.25rem 1rem;
  font-size: 0.875em;
  width: fit-content;
  text-align: center;
  height: 1lh;
  width: 1.5em;
  &::after {
    content: '▼';
    display: block;
    right: 0.5rem;
    position: absolute;
    top: 0;
    bottom: 0;
    height: fit-content;
    font-size: 0.5em;
    margin: auto;
    pointer-events: none;
  }
  select {
    all: unset;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    text-align-last: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

const RemoveButton = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  svg {
    display: block;
    height: 1.25rem;
    width: auto;
    rotate: 45deg;
  }
`

type CartProductItemProps = {
  data: Exclude<GQLCartQuery['cart'], undefined | null>['lines']['nodes'][number]
}
export const CartProductItem: FunctionComponent<CartProductItemProps> = ({data}) => {
  const cartId = useCartId()
  const [updating, setUpdating] = useState(false)
  const [cartLinesRemoveMutation] = useCartLinesRemoveMutation()
  const [cartLinesUpdateMutation] = useCartLinesUpdateMutation()
  const updateQty = async (qty: number) => {
    if(cartId){
      setUpdating(true)
      await cartLinesUpdateMutation({
        variables: {
          cartId,
          lines: [
            {
              id: data.id,
              quantity: qty
            }
          ]
        }
      })
      setUpdating(false)
    }
  }
  const remove = async () => {
    if(cartId){
      setUpdating(true)
      await cartLinesRemoveMutation({
        variables: {
          cartId,
          lineIds: [data.id]
        }
      })
      setUpdating(false)
    }
  }
  return <Outer className={classNames({updating})}>
    <Inner>
      <ImageContainer>
        <img src={data.merchandise.image?.url} />
      </ImageContainer>
      <TextContainer>
        <Name>
          {data.merchandise.title === 'Default Title' ? data.merchandise.product.title : data.merchandise.title}
        </Name>
        {/* <Volume>
          aaaaaaa
        </Volume> */}
        <Price>
          <small>¥</small>
          {formatDecimal(data.cost.totalAmount.amount)}
          <small>(tax in.)</small>
        </Price>
        <Qty>
          <select
            value={data.quantity}
            onChange={e => {
              const qty = Number(e.currentTarget.value)
              if (qty === 0) {
                remove()
              } else {
                updateQty(qty)
              }
            }}
          >
            {Array.from(Array(11), (_, i) => <option key={i} value={i}>{i}</option>)}
          </select>
        </Qty>
        <RemoveButton onClick={remove}>
          <SvgPlus size={8}/>
        </RemoveButton>
      </TextContainer>
    </Inner>
  </Outer>
}